import {ShortLocaleNameEnum} from '../../../provider/locale/locale-context-type';

export const LANGUAGE_MENU_KEY = 'language';

/**
 * Synthetic paths for custom menu items (Multichat, System status) that have no real route.
 * They are never used for navigation — only as a stable key so the item can be added to favorites.
 */
export const FAVORITE_VIRTUAL_PATH = {
    chatwoot: '/favorites-virtual/chatwoot',
    systemStatus: '/favorites-virtual/system-status',
} as const;

export const ruHelpDeskChatLocales = new Set([ShortLocaleNameEnum.ru, ShortLocaleNameEnum.kk]);

export const localStorageLastRoutePathKey = 'lastRoutePath';
